import * as actionTypes from "./actionTypes";
import { keyBy } from "lodash";

// Action for save page visit logs
export function savePageVisitLogs(payload) {
  return { type: actionTypes.SAVE_PAGE_VISIT_LOGS, payload };
}
// Action for save page visit logs success
export function savePageVisitLogsSuccess(payload) {
  return { type: actionTypes.SAVE_PAGE_VISIT_LOGS_SUCCESS, payload };
}

// Action for get page logs

export function getPageVisitLogs(payload) {
  return { type: actionTypes.GET_PAGE_VISIT_LOGS, payload };
}

export function getPageVisitLogsSuccess(payload) {
  console.log(payload);
  const userLogs = keyBy(payload.user_logs, (logs) => logs.weblogsUid);
  const pageLogs = keyBy(payload.page_logs, (logs) => logs.postUid);
  let platformLogs = {};
  if (payload["platform_logs"]) {
    const os_logs = keyBy(payload.platform_logs["os_logs"], (logs) => logs.id);
    console.log(os_logs);
    platformLogs["os_logs"] = os_logs;
    const browser_logs = keyBy(
      payload.platform_logs["browser_logs"],
      (logs) => logs.id
    );
    console.log(browser_logs);
    platformLogs["browser_logs"] = browser_logs;
    const country_logs = keyBy(
      payload.platform_logs["country_logs"],
      (logs) => logs.id
    );
    console.log(country_logs);
    platformLogs["country_logs"] = country_logs;
  }
  return {
    type: actionTypes.GET_PAGE_VISIT_LOGS_SUCCESS,
    payload: { userLogs, pageLogs, platformLogs },
  };
}
